var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
var Wrapper = styled.div.withConfig({ displayName: "Wrapper", componentId: "sc-cdergu" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"])));
export var getStudentsNames = function (ids, arr) {
    var result = ids.map(function (id) {
        var student = arr.find(function (s) { return s.id === id; });
        if (!student)
            return null;
        return _jsx("span", { children: student.fullName }, id);
    });
    return _jsx(Wrapper, { children: result }, void 0);
};
var templateObject_1;
